import { images } from '.';

const guests = [
    {
        id: 1,
        image: images.eventGuest1,
        name: "Dr. Michael Roberts",
        title: "AI Researcher",
        biography: "Dr. Michael Roberts is a distinguished AI researcher with expertise in machine learning, neural networks, and AI-driven automation. With a strong academic and industry background, he has contributed to groundbreaking AI innovations that are shaping the future of technology. His research focuses on ethical AI, deep learning advancements, and AI applications in business solutions.",
        contacts: {
            phone: "555-987-6543",
            email: "michael.roberts@example.com",
            website: "www.michaelrobertsai.com",
            company: "AI Innovations Lab",
            experience: "12+ Years in AI Research"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "AI Excellence Award (2022)",
            "Top 50 AI Researchers (2021)",
            "Best Research in Deep Learning (2020)"
        ],
        skills: [
            { id: 1, title: "Machine Learning", progress: 95 },
            { id: 2, title: "Neural Networks", progress: 90 },
            { id: 3, title: "AI Ethics & Policy", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.eventGuest2,
        name: "Sophia Chen",
        title: "Startup CEO",
        biography: "Sophia Chen is an innovative entrepreneur and CEO of a fast-growing tech startup. With a strong background in business strategy, product development, and startup scaling, she has successfully led her company to new heights. Sophia is passionate about fostering innovation, mentoring aspiring entrepreneurs, and building sustainable business models in the tech industry.",
        contacts: {
            phone: "555-789-1234",
            email: "sophia.chen@example.com",
            website: "www.sophiachenstartup.com",
            company: "NextGen Tech Solutions",
            experience: "10+ Years in Startup Leadership"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Top 30 Under 30 Entrepreneurs (2022)",
            "Best Startup Award (2021)",
            "Innovative Business Leader (2020)"
        ],
        skills: [
            { id: 1, title: "Business Strategy", progress: 94 },
            { id: 2, title: "Product Development", progress: 89 },
            { id: 3, title: "Startup Scaling", progress: 92 }
        ]
    },
    {
        id: 3,
        image: images.eventGuest3,
        name: "David Harrison",
        title: "Venture Investor",
        biography: "David Harrison is a seasoned venture investor with a keen eye for high-potential startups and disruptive innovations. With years of experience in investment strategy, market analysis, and startup funding, he has played a pivotal role in scaling multiple successful companies. David is passionate about guiding entrepreneurs toward sustainable growth and financial success.",
        contacts: {
            phone: "555-987-6543",
            email: "david.harrison@example.com",
            website: "www.davidharrisoninvestments.com",
            company: "Harrison Capital Ventures",
            experience: "15+ Years in Venture Investment"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Top 50 Investors in Tech (2023)",
            "Best Venture Capitalist Award (2021)",
            "Leader in Startup Funding (2019)"
        ],
        skills: [
            { id: 1, title: "Investment Strategy", progress: 95 },
            { id: 2, title: "Market Analysis", progress: 90 },
            { id: 3, title: "Startup Funding", progress: 93 }
        ]
    },
    {
        id: 4,
        image: images.eventGuest4,
        name: "Lisa Carter",
        title: "IT CTO",
        biography: "Lisa Carter is a highly accomplished Chief Technology Officer (CTO) with extensive experience in IT infrastructure, cybersecurity, and digital transformation. She has led multiple enterprise-level technology initiatives, driving innovation and efficiency across organizations. With a deep passion for emerging technologies, Lisa continues to shape the future of IT solutions.",
        contacts: {
            phone: "555-789-3210",
            email: "lisa.carter@example.com",
            website: "www.lisacartertech.com",
            company: "NextGen IT Solutions",
            experience: "12+ Years in IT Leadership"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Top 10 Women in Tech Leadership (2022)",
            "Best CTO Award (2021)",
            "Innovator in Digital Transformation (2020)"
        ],
        skills: [
            { id: 1, title: "IT Infrastructure", progress: 94 },
            { id: 2, title: "Cybersecurity", progress: 91 },
            { id: 3, title: "Digital Transformation", progress: 89 }
        ]
    },
    {
        id: 5,
        image: images.eventGuest5,
        name: "Mark Reynolds",
        title: "Digital Expert",
        biography: "Mark Reynolds is a seasoned Digital Expert with a strong background in digital transformation, online marketing, and data analytics. He has helped numerous businesses optimize their digital strategies, ensuring growth and success in the ever-evolving digital landscape. With a deep understanding of emerging trends, Mark is a sought-after consultant in the industry.",
        contacts: {
            phone: "555-654-9870",
            email: "mark.reynolds@example.com",
            website: "www.markreynolds.digital",
            company: "Digital Growth Solutions",
            experience: "10+ Years in Digital Strategy"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Top Digital Strategist Award (2022)",
            "Best Digital Transformation Consultant (2021)",
            "Leader in Online Marketing Innovation (2020)"
        ],
        skills: [
            { id: 1, title: "Digital Marketing", progress: 95 },
            { id: 2, title: "Data Analytics", progress: 92 },
            { id: 3, title: "SEO & SEM", progress: 90 }
        ]
    },
    {
        id: 6,
        image: images.eventGuest6,
        name: "Emily Foster",
        title: "Strategy Consultant",
        biography: "Emily Foster is a highly experienced Strategy Consultant specializing in business growth, market analysis, and organizational development. With a keen eye for identifying opportunities, she has helped numerous startups and enterprises refine their business strategies and achieve long-term success. Her analytical skills and innovative approach make her a trusted advisor in the industry.",
        contacts: {
            phone: "555-789-1234",
            email: "emily.foster@example.com",
            website: "www.emilyfosterstrategy.com",
            company: "Foster Strategy Group",
            experience: "12+ Years in Business Strategy"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Top Strategy Consultant Award (2022)",
            "Best Business Growth Advisor (2021)",
            "Leader in Market Analysis (2020)"
        ],
        skills: [
            { id: 1, title: "Business Strategy", progress: 95 },
            { id: 2, title: "Market Analysis", progress: 90 },
            { id: 3, title: "Organizational Development", progress: 88 }
        ]
    },
    {
        id: 7,
        image: images.eventGuest7,
        name: "James O'Connor",
        title: "Policy Analyst",
        biography: "James O'Connor is a distinguished Policy Analyst specializing in regulatory frameworks, economic policies, and technology governance. With extensive experience in public and private sectors, he provides data-driven insights that shape impactful policies. His expertise in legislative analysis and strategic advisory has contributed to key policy reforms in multiple industries.",
        contacts: {
            phone: "555-456-7890",
            email: "james.oconnor@example.com",
            website: "www.jamesoconnorpolicy.com",
            company: "Global Policy Institute",
            experience: "15+ Years in Policy Analysis"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Excellence in Policy Research (2022)",
            "Top Economic Policy Advisor (2021)",
            "Regulatory Impact Award (2020)"
        ],
        skills: [
            { id: 1, title: "Regulatory Analysis", progress: 93 },
            { id: 2, title: "Economic Policy", progress: 91 },
            { id: 3, title: "Technology Governance", progress: 89 }
        ]
    },
    {
        id: 8,
        image: images.eventGuest8,
        name: "Natalie Simmons",
        title: "SaaS Founder",
        biography: "Natalie Simmons is a visionary entrepreneur and the founder of a successful SaaS company, specializing in cloud-based business solutions. With a passion for innovation and user-centric design, she has built scalable platforms that empower businesses worldwide. Her expertise spans product development, go-to-market strategies, and SaaS growth optimization.",
        contacts: {
            phone: "555-678-1234",
            email: "natalie.simmons@example.com",
            website: "www.nataliesimmons.com",
            company: "NextGen SaaS Solutions",
            experience: "12+ Years in SaaS Industry"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Top SaaS Innovator (2022)",
            "Best Cloud Solutions Award (2021)",
            "Entrepreneur of the Year (2020)"
        ],
        skills: [
            { id: 1, title: "Product Development", progress: 95 },
            { id: 2, title: "SaaS Growth Strategies", progress: 92 },
            { id: 3, title: "Cloud Computing", progress: 90 }
        ]
    }
];

export default guests;